import axios from 'axios';
import {backendHost} from '../../config';

export const postOperator = (params) => {
    return axios.post(`${backendHost}/api/partners/admin/operators`, params);
};